import Track from "./Track";

export default function handleMachineGallery() {
    let homeSlider = document.getElementById('home-slider');

    if (homeSlider) {
        let slider = new Bee3D(homeSlider, {
            effect:     'coverflow',
            focus:      2,
            listeners:  {
                keys: true,
            },
            autoplay:   {
                enabled:    true,
                pauseHover: true,
            },
            navigation: {
                enabled: true,
            },
            loop:       {
                enabled: true,
            },
        });


        let numberOfSlides = $('.bee3D--slide.machine-gallery__item').length;
        // let startSlide = Math.ceil(numberOfSlides / 2) - 1;
        let startSlide = 0; // Start on first slide
        slider.el.slide(startSlide);
        $('.machine-gallery__pips .machine-gallery__pip[data-slide="' + startSlide + '"]').addClass(
            'machine-gallery__pip--active'
        );
        $('body')
            .not('.machine-gallery__pip--active')
            .on('click', '.machine-gallery__pips .machine-gallery__pip', function () {
                let slide = $(this).data('slide');
                $('.machine-gallery__pips .machine-gallery__pip.machine-gallery__pip--active').removeClass('machine-gallery__pip--active');
                $(this).addClass('machine-gallery__pip--active');
                slider.el.slide(slide);
            });
        slider.el.on('next', function (e) {
            let slide = e.index + 1;
            let numberOfSlides = $('.bee3D--slide.machine-gallery__item').length;
            $('.machine-gallery__pips .machine-gallery__pip.machine-gallery__pip--active').removeClass('machine-gallery__pip--active');

            if (slide <= numberOfSlides - 1) {
                $('.machine-gallery__pips .machine-gallery__pip[data-slide="' + slide + '"]').addClass('machine-gallery__pip--active');
            } else {
                $('.machine-gallery__pips .machine-gallery__pip[data-slide="0"]').addClass('machine-gallery__pip--active');
            }
        });
        slider.el.on('prev', function (e) {
            let slide = e.index - 1;
            let numberOfSlides = $('.bee3D--slide.machine-gallery__item').length;
            $('.machine-gallery__pips .machine-gallery__pip.machine-gallery__pip--active').removeClass('machine-gallery__pip--active');

            if (slide >= 0) {
                $('.machine-gallery__pips .machine-gallery__pip[data-slide="' + slide + '"]').addClass(
                    'machine-gallery__pip--active'
                );
            } else {
                $(
                    '.machine-gallery__pips .machine-gallery__pip[data-slide="' + (numberOfSlides - 1) + '"]'
                ).addClass('machine-gallery__pip--active');
            }
        });
    }
}

